module.exports = __webpack_public_path__ + "static/theghalileo2-df03d447ef41ee3019daa28a70e532fb.jpg";